'use strict';

import React, { Component, PropTypes } from 'react';
import DocumentTitle from './atoms/DocumentTitle';
import NotificationHost from './hosts/NotificationHost';
import OverlayHost from './hosts/OverlayHost';
import ModalHost from './hosts/ModalHost';
import ModalActionCreators from './actions/ModalActionCreators';
import ModalTypes from './constants/ModalTypes';
import AuthTypes from './constants/AuthTypes';

export default class AuthPopup extends Component {
  componentDidMount() {
    const { authType } = this.props;

    ModalActionCreators.showModal(authType === AuthTypes.SIGNUP ? ModalTypes.SIGNUP : ModalTypes.LOGIN);
  }

  render() {
    return (
      <DocumentTitle>
        <div>
          <NotificationHost />
          <OverlayHost />
          <ModalHost />
        </div>
      </DocumentTitle>
    );
  }
}

AuthPopup.propTypes = {
  authType: PropTypes.oneOf([AuthTypes.LOGIN, AuthTypes.SIGNUP]).isRequired
};


/** WEBPACK FOOTER **
 ** ./AuthPopup.jsx
 **/